import { render, staticRenderFns } from "./teamEntryForm.vue?vue&type=template&id=2549972f&scoped=true&"
import script from "./teamEntryForm.vue?vue&type=script&lang=js&"
export * from "./teamEntryForm.vue?vue&type=script&lang=js&"
import style0 from "./teamEntryForm.vue?vue&type=style&index=0&id=2549972f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549972f",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QCard,QCardSection,QSeparator,QBtn,QInput});
